import {hideOnClickOutside, isScrolledIntoView} from "../utils/utils";
import Onboarding from "../veritone/Onboarding";
import Collection from "../veritone/Collection";
import User from "../veritone/User";
import Dialog from "../components/Dialog";
import Modal from "../components/Modals";
import Pages from "../components/Pages";
import Order from "../veritone/Order";
import Asset from "../veritone/Asset";
import TabsDropdown from "../components/Tabs";

import { gsap } from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

let onboarding 	= new Onboarding();
let collection 	= new Collection();
let user 			    = new User();
let order 			= new Order();
let asset 			= new Asset();

export default class afterAjaxLoad {
    constructor() {
        const observer = new PerformanceObserver((list) => {
            for (const entry of list.getEntries()) {
                if (entry.initiatorType === "fetch") {
                    if(document.querySelectorAll('.create-collection-form')) {
                        document.querySelectorAll('.create-collection-form').forEach((createCollectionAction) => {
                            createCollectionAction.addEventListener("submit", (event) => {
                                event.preventDefault();
                                collection.veritoneCreateCollection(createCollectionAction);
                                event.stopImmediatePropagation();
                            });
                        });
                    }

                    if(document.querySelectorAll('.delete-collection')) {
                        document.querySelectorAll('.delete-collection').forEach((button) => {
                            button.addEventListener("click", (event) => {
                                event.preventDefault();
                                collection.veritoneDeleteCollection(button.dataset.id);
                                event.stopImmediatePropagation();
                            });
                        });
                    }

                    if(document.querySelectorAll('#update-user .submit-button')) {
                        document.querySelectorAll('#update-user .submit-button').forEach((button) => {
                            button.addEventListener("click", (event) => {
                                event.preventDefault();
                                user.veritoneUpdateUser();
                                event.stopImmediatePropagation();
                            });
                        });
                    }

					if(document.getElementById('load-more-bottom')) {
						let timer;
						window.addEventListener("scroll", (event) => {
							clearTimeout(timer);
							timer = setTimeout(() => {
								if(document.getElementById('load-more-bottom') && document.getElementById('load-more-bottom').disabled === false) {
									if (isScrolledIntoView(document.getElementById('load-more-bottom'))) {
										document.getElementById('load-more-bottom').style.display = "block";
										document.getElementById('load-more-bottom').disabled = true;
										document.body.classList.remove("loaded");
										asset.veritoneLoadMore('loadMore');
									}
								}
							}, 250);
						});
					}

					this.dialogs = document.querySelectorAll('[data-component="dialog"]');
					this.dialogs && this.dialogs.forEach((dialog)=>
					{
						new Dialog(dialog);
					})

                    document.body.addEventListener("click", (event) => {
                        if(event.target.closest('.share-collection-link')) {
                            let button = event.target.closest('.share-collection-link');
                            collection.veritoneShareCollectionLink(button.dataset.collectionid);
                            event.stopImmediatePropagation();
                        }

                        if(event.target.closest('[data-shareid]')) {
                            let button = event.target.closest('[data-shareid]');
                            collection.veritoneUnShareCollection(button.dataset.shareid);
                            event.stopImmediatePropagation();
                        }

                        if (event.target.closest('[data-downloadcollection]')) {
                            event.preventDefault();
                            let collectionDownload = event.target.closest('[data-downloadcollection]');
                            order.veritoneDownloadVideo(collectionDownload.dataset.downloadcollection, 'collection');
                            event.stopImmediatePropagation();
                        }

                        if (event.target.closest('[data-orderid]')) {
                            event.preventDefault();
                            let orderDownload = event.target.closest('[data-orderid]');
                            order.veritoneDownloadOrder(orderDownload.dataset.orderid, 'account');
                            event.stopImmediatePropagation();
                        }

                        if (event.target.closest('[data-aspera]')) {
                            event.preventDefault();
                            let orderID = event.target.closest('[data-aspera]');
                            order.veritoneAsperaDownload(orderID.dataset.aspera);
                            event.stopImmediatePropagation();
                        }

                        // let alertShown = false; 

						// if(event.target.closest('#copyToClipboard')) {
						// 	event.preventDefault();

                        //    // if (!alertShown) {
						// 	// Get the text field
						// 	let copyText = document.getElementById("copyPageURL");

						// 	// Select the text field
						// 	copyText.select();
						// 	copyText.setSelectionRange(0, 99999); // For mobile devices

						// 	// Copy the text inside the text field
						// 	navigator.clipboard.writeText(copyText.value);

						// 	// Alert the copied text
						// 	alert("Copied the text: " + copyText.value);
                        // //alertShown = true;
                        //    // }
                        // }

                        if (event.target.closest('#copyToClipboard')) {
                            event.preventDefault();
                        
                            let copyText = document.getElementById("copyPageURL");
                            let copiedMessage = document.getElementById("copiedMessage"); // The label
                        
                            // Select the text field
                            copyText.select();
                            copyText.setSelectionRange(0, 99999); // For mobile devices
                        
                            // Copy the text inside the text field
                            navigator.clipboard.writeText(copyText.value).then(() => {
                                // Show the "Copied!" message
                                copiedMessage.style.opacity = "1";
                        
                                // Hide it after 5 seconds
                                setTimeout(() => {
                                    copiedMessage.style.opacity = "0";
                                }, 5000);
                            }).catch(err => {
                                console.error("Failed to copy: ", err);
                            });
                        }
                        

                        if(event.target.closest('#license-agreement')) {
                            this.licenseAcceptance = event.target.closest('#license-agreement');
                            this.submitButtons = document.querySelector('#basket-checkout');
                            if(this.licenseAcceptance.checked) {
                                this.submitButtons.disabled = false;
                            } else {
                                this.submitButtons.disabled = true;
                            }
                        }

                        if(event.target.closest('.modal--close')) {
                            event.preventDefault();
                            document.body.classList.remove("modal--open");
                            setTimeout(() => {
                                document.querySelector('#modal__shell .modal__content').innerHTML = '';
                                document.querySelector('#modal__shell').className = '';
                                document.querySelector('#modal__shell').classList.add('modal');
                            }, 250);
                            if(window.app.smoother) {
                                window.app.smoother.paused(false);
                            }
                        }
                        if(event.target.closest('#button--summaryterms')) {
                            event.stopImmediatePropagation();
                            // Check fields have been completed
                            let intendedUseAssigned = false;
                            let intendedUseValues   = [];
                            let intendedUseFields   = document.querySelectorAll("[name='intendedUse']");

                            intendedUseFields.forEach((intendedUseField) => {
                                intendedUseValues.push(intendedUseField.value);
                            });

                            for(let i= 0; i<intendedUseValues.length; i++) {
                                if(intendedUseValues[i] === '') {
                                    // Empty field -> inform user
                                    intendedUseAssigned = false;
                                    document.getElementById('summaryterms-error').innerHTML = "Please select the Intended Use for all videos.";
                                    return false;
                                } else {
                                    intendedUseAssigned = true;
                                    document.getElementById('summaryterms-error').innerHTML = "";
                                }
                            }

                            if(intendedUseAssigned) {
                                // All fields populated, proceed by displaying next modal
                                this.modalContent = document.querySelector('#modal__shell .modal__content');
                                let formData = new FormData();
                                formData.append('modalName', 'summary-of-terms');

                                fetch('/wp/wp-admin/admin-ajax.php?action=injectModal', {
                                    method: 'POST',
                                    body: formData,
                                })
                                .then(response => response.json())
                                .then(data => {
                                    this.modalContent.innerHTML = '';
                                    this.modalContent.insertAdjacentHTML('beforeend', data['modal']);
                                    document.body.classList.add('modal--open');
                                    document.body.classList.add("loaded");
                                    document.getElementById('modal__shell').click();

                                    gsap.to(this.modalContent.closest('#modal__shell'), { duration: .1, scrollTo: 0 });
                                })
                            }

                            event.preventDefault();
                            event.stopImmediatePropagation();
                        }

						if (event.target.closest('[data-modal]')) {
                            if(window.app.smoother) {
                                window.app.smoother.paused(true);
                            }
						}

                        // Check for and initialise form page functionality
                        let formPages 		= document.querySelector('#modal__shell .modal__content').querySelectorAll('[data-formpage="*"]')
                        let formPageButtons = document.querySelector('#modal__shell .modal__content').querySelectorAll('[data-formpagelink]')

                        formPages && formPageButtons.forEach((formPageButton)=> {
                            formPageButton.addEventListener("click", (event) => {
                                event.preventDefault()

                                // Close all pages
                                let activePage 		= document.querySelector('#modal__shell .modal__content').querySelector('.form-page--active')
                                activePage.classList.remove('form-page--active')

                                // Find and show only active page from data attribute
                                let targetPageID		= event.target.dataset.formpagelink
                                let targetPage 		= document.querySelector('#modal__shell .modal__content').querySelector(`[data-formpage="${targetPageID}"]`)
                                targetPage.classList.add('form-page--active')

                                // Update form page indicator
                                let formPageIndicator = document.querySelector('#modal__shell .modal__content').querySelector('.form-page-indicator__num')
                                formPageIndicator.innerHTML = targetPageID

                                let scrollContainer = formPageButton.closest('#modal__shell')
                                if (scrollContainer) {
                                	gsap.to(formPageButton.closest('#modal__shell'), { duration: .1, scrollTo: 0 });
                                }
                            })
                        })

                        // if (event.target.closest('[data-component="dialog"]')) {
                        //     let dialog = event.target.closest('[data-component="dialog"]');
                        //     if (dialog.classList.contains('pill--active') && dialog.classList.contains('dialog--open')) {
                        //         dialog.classList.remove("pill--active");
                        //         dialog.classList.remove("dialog--open");
                        //     }
                        //     if (!dialog.classList.contains('pill--active') && !dialog.classList.contains('dialog--open')) {
                        //         dialog.classList.add("pill--active");
                        //         dialog.classList.add("dialog--open");
                        //     }
                        //     hideOnClickOutside( dialog, null, ['pill--active','dialog--open'] )
                        // }

                        if (event.target.closest('[data-page]:not(.tab)')) {
                            document.body.classList.remove("loaded");
                            let pageLoader = event.target.closest('[data-page]:not(.tab)');

                            let pageName 		= pageLoader.dataset.page;
                            let assetID 			= pageLoader.dataset.assetid;
                            let collectionID 	= pageLoader.dataset.collectionid;
							let orderID 			= pageLoader.dataset.order;
                            let wpPage	 		= pageLoader.dataset.wppage;
                            let formData 		= new FormData();
                            formData.append('pageName', pageName);

                            if(assetID) {
                                formData.append('assetID', assetID);
                            }

                            if(collectionID) {
                                formData.append('collectionID', collectionID);
                            }

							if(orderID) {
								formData.append('orderID', orderID);
							}

                            if(wpPage) {
                                formData.append('wpPage', wpPage);
                            }

                            fetch('/wp/wp-admin/admin-ajax.php?action=injectPage', {
                                method: 'POST',
                                body: formData,
                            })
                            .then(response => response.json())
                            .then(data => {
                                if(data['page']) {
                                    // Clear page shell
                                    document.querySelector('#page-shell').innerHTML = '';

                                    // Append new data to page shell
                                    document.querySelector('#page-shell').insertAdjacentHTML('beforeend', data['page']);

                                    // Update URL to match new page
                                    window.history.pushState('', '', data['url']);

                                    // Stop page loader
                                    document.body.classList.add("loaded");
                                }
                            })
                            event.stopImmediatePropagation();
                        }
                    });

                    document.addEventListener("submit", (e) => {
                        const loginAction 			= e.target.closest('#onboarding-login');
                        const requestPasswordReset 	= e.target.closest('#onboarding-request-password-reset');
                        const signUp 				= e.target.closest('#onboarding-signup');

                        if(loginAction) {
                            e.preventDefault();
                            onboarding.veritoneLogin();
                            
                        }

                        if(requestPasswordReset) {
                            e.preventDefault();
                            onboarding.veritoneRequestPasswordReset();
                        }

                        if(signUp) {
                            e.preventDefault();
                            onboarding.veritoneSignUp();
                        }
                        e.stopImmediatePropagation();
                    });
                }
            }
        });

        observer.observe({
            entryTypes: ["resource"]
        });
    }
}
